//import zaunspitzen luxus
import img_zaunspitze_55113293 from "./zaunspitzen/zaunspitze_55113293.jpg";
import img_zaunspitze_55113297 from "./zaunspitzen/zaunspitze_55113297.jpg";
import img_zaunspitze_55113266 from "./zaunspitzen/zaunspitze_55113266.jpg";
import img_zaunspitze_55011710 from "./zaunspitzen/zaunspitze_55011710.jpg";
import img_zaunspitze_55113244 from "./zaunspitzen/zaunspitze_55113244.jpg";
import img_zaunspitze_55113270 from "./zaunspitzen/zaunspitze_55113270.jpg";
import img_zaunspitze_55113285 from "./zaunspitzen/zaunspitze_55113285.jpg";
import img_zaunspitze_55113085 from "./zaunspitzen/zaunspitze_55113085.jpg";
import img_zaunspitze_55113299 from "./zaunspitzen/zaunspitze_55113299.jpg";

//import form schiebetor
import form_geschwungen_schiebetor from './tore/schiebetore/form/geschwungen.svg';
import form_gerade_schiebetor from './tore/schiebetore/form/gerade.svg';

//import portfolio
import {portfolio_zaune} from './zaune/portfolio/portfolio';
import form_geschwungen_fluegeltor from './tore/fluegeltore/form/geschwungen.svg';
import form_gerade_fluegeltor from './tore/fluegeltore/form/gerade.svg';
import {portfolio_fluegeltor, portfolio_fluegeltor_videos} from './tore/fluegeltore/portfolio/portfolio';
import {portfolio_schiebetor, portfolio_schiebetor_videos} from './tore/schiebetore/portfolio/portfolio';
import {portfolio_pforte} from './pforten/portfolio/portfolio';
import {portfolio_edelstahlgelaender} from './gelaender/edelstahlgelaender/portfolio/portfolio';
import {portfolio_edelstahlgelaender_glas} from './gelaender/edelstahlgelaender_glas/portfolio/portfolio';
import {portfolio_treppengelaender} from './gelaender/edelstahlgelaender_ohne_fuellung/portfolio/portfolio';
import {portfolio_stahlgelaender} from './gelaender/stahlgelaender/portfolio/portfolio';
import {portfolio_stahltreppe} from './stahltreppen/portfolio/portfolio';

//import kappen
import kappe_gerade from './pfosten/kappe_gerade.png';
import kappe_spitz from './pfosten/kappe_spitz.png';
import kappe_rund from './pfosten/kappe_rund.png';

//import briefkasten
import briefkasten_ohne from './zaune/bierfkasten/briefkasten_ohne.png';
import briefkasten_links from './zaune/bierfkasten/briefkasten_links.png';
import briefkasten_rechts from './zaune/bierfkasten/briefkasten_rechts.png';

//import geländer
import gelaender_aussen from './gelaender/auswahl/aussen.jpg';
import gelaender_innen from './gelaender/auswahl/innen.jpg';
import gelaender_glas from './gelaender/auswahl/glas.jpg';
import gelaender_ohne_fuellung from './gelaender/auswahl/ohne_fuellung.jpg';

//import grundriss
import i_form from './grundriss/i-form.svg';
import l_form from './grundriss/l-form.svg';
import u_form from './grundriss/u-form.svg';
import z_form from './grundriss/z-form.svg';

//import handlauf endkappe
import handlauf_endkappe_gerade from './handlauf_endkappe/gerade.jpg';
import handlauf_endkappe_gewoelbt from './handlauf_endkappe/gewoelbt.jpg';
import handlauf_endkappe_bogen from './handlauf_endkappe/bogen.jpg';

//import pfosten befestigungsart
import pfosten_befestigung_aufgesetzt from './pfosten_befestigung/aufgesetzt.svg';
import pfosten_befestigung_vorgesetzt from './pfosten_befestigung/vorgesetzt.svg';
import pfosten_befestigung_unten from './pfosten_befestigung/befestigung_unten.svg';

//import glasvordächer
import glasvordach_freitragend from './vordaecher/auswahl/glasvordach_freitragend.png';
import glasvordach_trave from './vordaecher/auswahl/glasvordach_trave.png';
import glasvordach_zugstaebe from './vordaecher/auswahl/glasvordach_zugstaebe.png';
import glasvordach_pfosten from './vordaecher/auswahl/glasvordach_pfosten.png';

//import auswahl Products
import zaun from './auswahl/zaun.jpg';
import tor from './auswahl/tor.jpg';
import pforte from './auswahl/pforte.jpg';
import gelaender from './auswahl/gelaender.jpg';
import vordach from './auswahl/vordach.jpg';
import stahltreppe from './auswahl/stahltreppe.jpg';

//import stahltreppe geländer
//import stahltreppe_ohne_gelaender from './stahltreppen/stahltreppe_ohne_gelaender.svg';
import stahltreppe_gelaender_einseitig from './stahltreppen/Gelaender/stahltreppe_gelaender_einseitig_blue.png';
import stahltreppe_gelaender_beidseitig from './stahltreppen/Gelaender/stahltreppe_gelaender_beidseitig_blue.png';
import stahltreppe_gelaender_ohne from './stahltreppen/Gelaender/stahltreppe_ohne_gelaender.png';

//import stahltreppe geländer muster
import stahltreppe_gelaender_waagerecht from './stahltreppen/Gelaender/gelaender_waagerecht.png';
import stahltreppe_gelaender_hochkant from './stahltreppen/Gelaender/gelaender_hochkant.png';
import stahltreppe_gelaender_blech from './stahltreppen/Gelaender/gelaender_blech.png';
import stahltreppe_gelaender_lochblech from './stahltreppen/Gelaender/gelaender_lochblech.png';

//stahltreppe geländer muster
export const stahltreppe_gelaender_muster = [
    {imgsrc: stahltreppe_gelaender_waagerecht, titel: 'Stäbe waagerecht'},
    {imgsrc: stahltreppe_gelaender_hochkant, titel: 'Stäbe hochkant'},
    {imgsrc: stahltreppe_gelaender_blech, titel: 'Blech'},
    {imgsrc: stahltreppe_gelaender_lochblech, titel: 'Lochblech'}
]

//stahltreppe geländer
export const stahltreppe_gelaender = [
    //{imgsrc: stahltreppe_ohne_gelaender, titel: 'Ohne Geländer'},
    {imgsrc: stahltreppe_gelaender_einseitig, titel: 'Geländer (einseitig)'},
    {imgsrc: stahltreppe_gelaender_beidseitig, titel: 'Geländer (beidseitig)'},
    {imgsrc: stahltreppe_gelaender_ohne, titel: 'Kein Geländer'}
]

//Auswahl Products
export const auswahlProducts = [
    {imgsrc: zaun, titel: "Zäune", path: "zaune"},
    {imgsrc: tor, titel: "Tore", path: "tore"},
    {imgsrc: pforte, titel: "Pforte", path: "pforten"},
    {imgsrc: stahltreppe, titel: "Stahltreppe", path: "stahltreppe"},
    {imgsrc: gelaender, titel: "Geländer", path: "gelaender"},
    {imgsrc: vordach, titel: "Vordächer", path: "vordaecher"}
];

//zäune
export const zaune_auswahl = {
    portfolio: portfolio_zaune,
    titel: 'Zaun',
    price: 350,
    desc: `Unser Angebot enthält eine breite Palette von Zäunen die nach fertigen Mustern hergestellt werden.\n
    Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten`,
    content: [
        {titel: 'Breite ab:', item: '100 cm'},
        {titel: 'Höhe ab:', item: '80 cm'},
        {titel: 'Beschichtung:', item: 'Feuerverzinkt und pulverbeschichtet'},
        {titel: 'Farbe:', item: 'Athrazitgrau RAL 7016'},
        {titel: 'Pfosten:', item: 'Keine Pfosten'},
        {titel: 'Inklusive Montage', item: ''},
        {titel: 'Hochwertige Handwerksqualität', item: ''},
    ]
}

//pforte
export const pforte_auswahl = {
    portfolio: portfolio_pforte,
    titel: 'Pforte',
    price: 650,
    desc: `Unser Angebot enthält eine breite Palette von Pforten bzw. Gartentore die nach fertigen Mustern hergestellt werden.\n
    Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten`,
    content: [
        {titel: 'Breite ab:', item: '80 cm'},
        {titel: 'Höhe ab:', item: '100 cm'},
        {titel: 'Beschichtung:', item: 'Feuerverzinkt und pulverbeschichtet'},
        {titel: 'Farbe:', item: 'Athrazitgrau RAL 7016'},
        {titel: 'Pfosten:', item: 'Keine Pfosten'},
        {titel: 'Inklusive Montage', item: ''},
        {titel: 'Hochwertige Handwerksqualität', item: ''},
    ]
}

//tore
export const tore_auswahl = [
    {
        portfolio: portfolio_schiebetor,
        videos: portfolio_schiebetor_videos,
        titel: 'Schiebetor',
        price: 1685,
        desc: `Unser Angebot enthält eine kleine Auswahl von Schiebetoren die nach fertigen Mustern hergestellt werden können.\n
        Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten`,
        content: [
            {titel: 'Breite ab:', item: '240 cm'},
            {titel: 'Höhe ab:', item: '100 cm'},
            {titel: 'Beschichtung:', item: 'Feuerverzinkt und pulverbeschichtet'},
            {titel: 'Farbe:', item: 'Athrazitgrau RAL 7016'},
            {titel: 'Pfosten:', item: 'Keine Pfosten'},
            {titel: 'Inklusive Montage', item: ''},
            {titel: 'Hochwertige Handwerksqualität', item: ''},
        ]
    },
    {
        portfolio: portfolio_fluegeltor,
        videos: portfolio_fluegeltor_videos,
        titel: 'Flügeltor',
        price: 1550,
        desc: `Unser Angebot enthält eine kleine Auswahl von Flügeltoren die nach fertigen Mustern hergestellt werden können. \n
        Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten.`,
        content: [
            {titel: 'Breite ab:', item: '240 cm'},
            {titel: 'Höhe ab:', item: '100 cm'},
            {titel: 'Beschichtung:', item: 'Feuerverzinkt und pulverbeschichtet'},
            {titel: 'Farbe:', item: 'Athrazitgrau RAL 7016'},
            {titel: 'Pfosten:', item: 'Keine Pfosten'},
            {titel: 'Inklusive Montage', item: ''},
            {titel: 'Hochwertige Handwerksqualität', item: ''},
        ]
    }
]

//geländer
export const gelaender_auswahl = [
    {
        portfolio: portfolio_stahlgelaender,
        titel: 'Stahlgeländer',
        price: 330,
        desc: `Unser Angebot enthält eine breite Palette von Geländer die nach fertigen Mustern hergestellt werden.\n
        Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten`,
        content: [
            {titel: 'Material:', item: 'Stahl'},
            {titel: 'Form:', item: 'I-Form / L-Form / U-Form / Sonderform '},
            {titel: 'Oberfläche:', item: 'Fuerverzinkt oder wahlweise feuerverzinkt und pulverbeschichtet (gemäß Konfiguration)'},
            {titel: 'Länge ab:', item: '100 cm'},
            {titel: 'Höhe ab Oberkante des fertigen Fußbodens:', item: '100 cm'},
            {titel: 'Handlauf:', item: 'Rundrohr 33,7 mm / Rundrohr 42,4 mm / Rechteck 40 x 30 mm / Quadraht 45 x 45 mm'},
            {titel: 'Pfosten:', item: 'Rundrohr 42,4 mm / Rundrohr 60 mm / Rechteck 50 x 30 mm / Quadraht 40 x 40 mm / Quadraht 60 x 60 mm'},
            {titel: 'Befestigungsvariante', item: 'Aufgesetzt / Vorgesetzt / Befestigung von Unten'},
            {titel: 'Inklusive Montage', item: ''},
            {titel: 'Hochwertige Handwerksqualität', item: ''},
        ]
    },
    {
        portfolio: portfolio_edelstahlgelaender,
        titel: 'Edelstahlgeländer',
        price: 350,
        desc: `Unser Angebot enthält eine breite Palette von Geländer die nach fertigen Mustern hergestellt werden.\n
        Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten`,
        content: [
            {titel: 'Material:', item: 'Edelstahl'},
            {titel: 'Form:', item: 'I-Form / L-Form / U-Form / Sonderform '},
            {titel: 'Länge ab:', item: '100 cm'},
            {titel: 'Höhe ab Oberkante des fertigen Fußbodens:', item: '100 cm'},
            {titel: 'Handlauf:', item: 'Rundrohr 33,7 mm / Rundrohr 42,4 mm / Rechteck 40 x 30 mm / Quadraht 45 x 45 mm'},
            {titel: 'Pfosten:', item: 'Rundrohr 42,4 mm / Rundrohr 60 mm / Rechteck 50 x 30 mm / Quadraht 40 x 40 mm / Quadraht 60 x 60 mm'},
            {titel: 'Befestigungsvariante', item: 'Aufgesetzt / Vorgesetzt / Befestigung von Unten'},
            {titel: 'Inklusive Montage', item: ''},
            {titel: 'Hochwertige Handwerksqualität', item: ''},
        ]
    },
    {
        portfolio: portfolio_edelstahlgelaender_glas,
        titel: 'Geländer mit Glas',
        price: 450,
        desc: `Unser Angebot enthält eine breite Palette von Geländer die nach fertigen Mustern hergestellt werden.\n
        Es besteht jedoch die Möglichkeit, Bestellungen auf Basis eines individuellen Entwurfs des Kunden zu realisierten`,
        content: [
            {titel: 'Material:', item: 'Edelstahl / Stahl '},
            {titel: 'Form:', item: 'I-Form / L-Form / U-Form / Sonderform '},
            {titel: 'Oberfläche:', item: 'Fuerverzinkt oder wahlweise feuerverzinkt und pulverbeschichtet (gemäß Konfiguration)'},
            {titel: 'Länge ab:', item: '100 cm'},
            {titel: 'Höhe ab Oberkante des fertigen Fußbodens:', item: '100 cm'},
            {titel: 'Handlauf:', item: 'Rundrohr 33,7 mm / Rundrohr 42,4 mm / Rechteck 40 x 30 mm / Quadraht 45 x 45 mm'},
            {titel: 'Pfosten:', item: 'Rundrohr 42,4 mm / Rundrohr 60 mm / Rechteck 50 x 30 mm / Quadraht 40 x 40 mm / Quadraht 60 x 60 mm'},
            {titel: 'Befestigungsvariante', item: 'Aufgesetzt / Vorgesetzt / Befestigung von Unten'},
            {titel: 'Glastönung', item: 'Klar / Milch / Anthrazit'},
            {titel: 'Inklusive Montage', item: ''},
            {titel: 'Hochwertige Handwerksqualität', item: ''},
        ]
    },
    {
        portfolio: portfolio_treppengelaender,
        titel: 'Treppenhandlauf Edelstahl',
        price: 350,
        desc: 'Das Treppengeländer wird seitlich an der Hauswand und auf der Treppe bzw. den Treppenstufen oder vor der Treppe montiert.',
        content: [
            {titel: 'Material:', item: 'Edelstahl '},
            {titel: 'Länge ab:', item: '80 cm'},
            {titel: 'Höhe ab ca:', item: '92 cm'},
            {titel: 'Handlauf:', item: 'Rundrohr 33,7 mm / Rundrohr 42,4 mm / Rechteck 40 x 30 mm / Quadraht 45 x 45 mm'},
            {titel: 'Pfosten:', item: 'Rundrohr 42,4 mm / Rundrohr 60 mm / Rechteck 50 x 30 mm / Quadraht 40 x 40 mm / Quadraht 60 x 60 mm'},
            {titel: 'Befestigungsvariante', item: 'Aufgesetzt / Vorgesetzt'},
            {titel: 'Inklusive Montage', item: ''},
            {titel: 'Hochwertige Handwerksqualität', item: ''},
        ]
    }
]

//glasvordächer
export const glasvordaecher_auswahl = [
    {
        imgsrc: glasvordach_freitragend,
        titel: 'Vordach freitragend',
        price: 450,
        content: [
            {titel: 'Rahmenloses System mit schmalem Wandklemmprofil', item: ''},
            {titel: 'Leichtes, elegantes Design', item: ''},
            {titel: 'Hohe Stabilität und hohe Tragkraft', item: ''},
            {titel: 'Breite ab: ', item: '40 - 600 cm'},
            {titel: 'Tiefe ab: ', item: '20 - 115 cm'},
            {titel: 'Glastönung: ', item: 'Klar / Milch / Anthrazit'},
            {titel: 'Inklusive Montage', item: ''},
        ]
    },
    {
        imgsrc: glasvordach_trave,
        titel: 'Vordach mit Rohrträgern (Trave)',
        price: 650,
        content: [
            {titel: 'Einzelträger aus hochwertigem Edelstahl', item: ''},
            {titel: 'Alternativ mit verbundenem Rohrrahmen', item: ''},
            {titel: 'Geeignet für beengte Einbausituationen', item: ''},
            {titel: 'Breite ab: ', item: '90 cm'},
            {titel: 'Tiefe ab: ', item: '70 - 155 cm'},
            {titel: 'Glastönung: ', item: 'Klar / Milch / Anthrazit'},
            {titel: 'Inklusive Montage', item: ''},
        ]
    },
    {
        imgsrc: glasvordach_zugstaebe,
        titel: 'Vordach mit Zugstangen',
        price: 515,
        content: [
            {titel: 'Zugstreben und punktuelle Glashalter aus Edelstahl', item: ''},
            {titel: 'Individuelle Maße, Zuschnitte und Befestigungen', item: ''},
            {titel: 'Für eingeschränkte Montageverhältnisse geeignet', item: ''},
            {titel: 'Breite ab: ', item: '90 cm'},
            {titel: 'Tiefe ab: ', item: '70 - 179 cm'},
            {titel: 'Glastönung: ', item: 'Klar / Milch / Anthrazit'},
            {titel: 'Inklusive Montage', item: ''},
        ]
    },
    {
        imgsrc: glasvordach_pfosten,
        titel: 'Glasvordach mit Pfosten',
        price: 715,
        content: [
            {titel: 'Breite ab: ', item: '90 cm'},
            {titel: 'Tiefe ab: ', item: '70 - 179 cm'},
            {titel: 'Pfosten:', item: 'Rundrohr 42,4 mm / Rundrohr 60 mm'},
            {titel: 'Glastönung: ', item: 'Klar / Milch / Anthrazit'},
            {titel: 'Inklusive Montage', item: ''},
        ]
    }
]

//stahltreppe
export const stahltreppe_auswahl = {
    portfolio: portfolio_stahltreppe,
    titel: 'Stahltreppe',
    price: 1298,
    desc: '',
    content: [
        {titel: 'Material:', item: 'Stahl '},
        {titel: 'Oberfläche:', item: 'Fuerverzinkt oder wahlweise feuerverzinkt und pulverbeschichtet (gemäß Konfiguration)'},
        {titel: 'Geländer ein- oder beidseitig', item: ''},
        {titel: 'Geschosshöhe ab:', item: '83 cm (5 Stufen)'},
        {titel: 'Stufenbreite:', item: '600 mm / 700 mm / 800 mm / 900 mm / 1000 mm'},
        {titel: 'Handlauf für das Geländer:', item: 'Rundrohr 33,7 mm / Rundrohr 42,4 mm / Rechteck 40 x 30 mm / Quadraht 45 x 45 mm'},
        {titel: 'Mit oder ohne Podest', item: ''},
        {titel: 'Inklusive Montage', item: ''},
        {titel: 'Hochwertige Handwerksqualität', item: ''},
    ]
}

//pfosten befestigungsart
export const pfosten_befestigungsart = [
    {imgsrc: pfosten_befestigung_aufgesetzt, titel: 'Aufgesetzt'},
    {imgsrc: pfosten_befestigung_vorgesetzt, titel: 'Vorgesetzt'},
    {imgsrc: pfosten_befestigung_unten, titel: 'Befestigung von Unten'}
]

//handlauf endstücke
export const handlauf_endkappen = [
    {imgsrc: handlauf_endkappe_bogen, titel: 'Gebogen'},
    {imgsrc: handlauf_endkappe_gerade, titel: 'Gerade'},
    {imgsrc: handlauf_endkappe_gewoelbt, titel: 'Gewölbt'}
]

//grundriss auswahl
export const grundriss_auswahl = [
    {imgsrc: i_form, titel: 'I-Form'},
    {imgsrc: l_form, titel: 'L-Form'},
    {imgsrc: u_form, titel: 'U-Form'},
    {imgsrc: z_form, titel: 'Sonderform'}
]

//glastönung
export const glastoenung = [
    {color: 'C0E9EC', titel: 'Klar'},
    {color: 'D2D2D2', titel: 'Milch'},
    {color: '414951', titel: 'Anthrazit'}
]

//geländer auswahl
export const gelaender_auswahl_menu = [
    {imgsrc: gelaender_aussen, titel: 'Stahlgeländer', path: '/gelaender/stahlgelaender'},
    {imgsrc: gelaender_innen, titel: 'Edelstahlgeländer', path: '/gelaender/edelstahlgelaender'},
    {imgsrc: gelaender_glas, titel: 'Geländer mit Glas', path: '/gelaender/gelaender_glas'},
    {imgsrc: gelaender_ohne_fuellung, titel: 'Treppengeländer Edelstahl', path: '/gelaender/treppengelaender_edelstahl'}
]

//form auswahl flügeltore
export const form_fluegeltor = [
    {imgsrc: form_gerade_fluegeltor, titel: 'Gerade', imgalt: 'Flügeltor gerade'},
    {imgsrc: form_geschwungen_fluegeltor, titel: 'Geschwungen', imgalt: 'Flügeltor geschwungen'},
]

//form auswahl schiebetore
export const form_schiebetor = [
    {imgsrc: form_gerade_schiebetor, titel: 'Gerade', imgalt: 'Schiebetor gerade'},
    {imgsrc: form_geschwungen_schiebetor, titel: 'Geschwungen', imgalt: 'Schiebetor geschwungen'},
]

//Farben
export const colors = [
    {color: "000000", titel: "Schwarz RAL 9005"},
    {color: "4A4C4F", titel: "Athrazitgrau RAL 7016"},
    {color: "9CA5AC", titel: "Grau RAL 7040"},
    {color: "8B8C7A", titel: "Steingrau RAL 7030"},
    {color: "FAFAFA", titel: "Weiss RAL 9016"},
    {color: "0A4A80", titel: "Blau RAL 5010"},
    {color: "5E2029", titel: "Weinrot RAL 3005"},
    {color: "2F4538", titel: "Moosgrün RAL 6005"},
    {color: "52443A", titel: "Braun RAL 8014"},
]

//zaunsspitzen
export const zaunspitzen = [
    {img: "", titel: "Keine Spitzen"},
    {img: img_zaunspitze_55113266, titel: "Zaunspitze - 55113266"},
    {img: img_zaunspitze_55113293, titel: "Zaunspitze - 55113293"},
    {img: img_zaunspitze_55113297, titel: "Zaunspitze - 55113297"},
    {img: img_zaunspitze_55011710, titel: "Zaunspitze - 55011710"},
    {img: img_zaunspitze_55113244, titel: "Zaunspitze - 55113244"},
    {img: img_zaunspitze_55113270, titel: "Zaunspitze - 55113270"},
    {img: img_zaunspitze_55113285, titel: "Zaunspitze - 55113285"},
    {img: img_zaunspitze_55113085, titel: "Zaunspitze - 55113085"},
    {img: img_zaunspitze_55113299, titel: "Zaunspitze - 55113299"}
]

//pfosten
export  const pfosten = [
    {titel: 'Keine Pfosten, ich habe eigene oder ein Mauerwerk'},
    {titel: 'Ich brauche welche'}
]

//kappen
export const kappen = [
    {titel: 'Gerade', img: kappe_gerade},
    {titel: 'Pyramide', img: kappe_spitz},
    {titel: 'Kugel', img: kappe_rund},
]

//briefkasten
export const briefkasten = [
    {titel: 'kein', img: briefkasten_ohne},
    {titel: 'links', img: briefkasten_links},
    {titel: 'rechts', img: briefkasten_rechts}
]

